import React from 'react';
import './main.css';
import { NavLink } from 'react-router-dom';
import t from '../../i8n';

class MenuItem extends React.Component {
	render(){
		return (
			<NavLink {...this.props} className="menu-link" activeClassName="active">
				<span>{this.props.text || "Link"}</span>
			</NavLink>
		);
	}
}

export default
class Menu extends React.Component {
	render(){
		return (
			<div className="menu">
				<div className="menu-header-bar"></div>
				<MenuItem to="/" text={t({pl: "Strona główna", en: "Main page"})} exact />
				<MenuItem to="/wspolpraca" text={t({pl: "Współpraca", en: "Partners"})} />
				<MenuItem to="/projekty" text={t({pl: "Projekty własne", en: "Personal projects"})} />
				<MenuItem to="/kontakt" text={t({pl: "Kontakt i kompetencje", en: "Contact and competences"})} />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Content/Menu/index.js